import { useState, useEffect } from "react"
export function useRouteListener() {
  const [currentPath, setCurrentPath] = useState("")

  useEffect(() => {
    // 获取初始路径
    const getCurrentPath = () => {
      return window.location.pathname
    }

    // 设置初始路径
    setCurrentPath(getCurrentPath())

    // 监听浏览器前进/后退按钮
    const handlePopState = () => {
      setCurrentPath(getCurrentPath())
    }

    // 监听 pushState 和 replaceState（用于SPA路由）
    const originalPushState = history.pushState
    const originalReplaceState = history.replaceState

    history.pushState = (...args) => {
      originalPushState.apply(history, args)
      setCurrentPath(getCurrentPath())
    }

    history.replaceState = (...args) => {
      originalReplaceState.apply(history, args)
      setCurrentPath(getCurrentPath())
    }

    // 添加事件监听器
    window.addEventListener("popstate", handlePopState)

    // 清理函数
    return () => {
      window.removeEventListener("popstate", handlePopState)
      history.pushState = originalPushState
      history.replaceState = originalReplaceState
    }
  }, [])

  // 程序化导航函数
  const navigateTo = (path) => {
    window.history.pushState({}, "", path)
    setCurrentPath(path)
  }

  return {
    currentPath,
    navigateTo,
  }
}
